<div class="form-card">
  <h3 class="section-title"><i class="bi bi-person"></i> Personal</h3>

    <form [formGroup]="userProfileForm">

  <div class="form-grid">
    <div class="form-group full">
      <label><i class="bi bi-person"></i> Full Name <span>*</span></label>
      <input
        type="text"
        placeholder="e.g. Priya Sharma"
        formControlName="fullName"
      />
      <small class="text-danger smaller-text" *ngIf="(userProfileForm.get('fullName')?.dirty
       || userProfileForm.get('fullName')?.touched) 
       && userProfileForm.get('fullName')?.errors?.['required']">Full Name is required</small>

        <small class="text-danger smaller-text" *ngIf="(userProfileForm.get('fullName')?.dirty 
          || userProfileForm.get('fullName')?.touched) 
          && userProfileForm.get('fullName')?.errors?.['alphabetsOnly']"> Only alphabets are allowed </small>

    </div>

    <div class="form-group">
      <label>
        <i class="bi bi-envelope"></i>
        Email <span>*</span></label
      >
      <input
        type="email"
        placeholder="e.g. priya@gmail.com"
        formControlName="email"
      />
      <small class="text-danger smaller-text" 
      *ngIf="userProfileForm.get('email')?.touched && userProfileForm.get('email')?.invalid">
      <span *ngIf="userProfileForm.get('email')?.errors?.['required']">Email is required</span>
      <span *ngIf="userProfileForm.get('email')?.errors?.['email']">  Enter a valid email</span>
    </small>

    </div>

    <div class="form-group">
      <label>
        <i class="bi bi-telephone"></i>
        Phone Number <span>*</span></label
      >
      <input
        type="text"
        placeholder="e.g. +91 98765 43210"
        formControlName="phone"
        maxlength="10"
      />

      <small class="text-danger smaller-text"  *ngIf="(userProfileForm.get('phone')?.dirty 
      || userProfileForm.get('phone')?.touched)
      && userProfileForm.get('phone')?.errors?.['required']">Phone number is required</small>

      <small class="text-danger smaller-text" *ngIf="(userProfileForm.get('phone')?.dirty 
      || userProfileForm.get('phone')?.touched)
      && userProfileForm.get('phone')?.errors?.['pattern']"> Enter a valid 10-digit number</small>
    </div>

    <div class="form-group">
      <label>
        <i class="bi bi-geo-alt"></i>
        Location</label
      >
      <input
        type="text"
        placeholder="e.g. Mumbai, India"
        formControlName="location"
      />
        <small class="text-danger smaller-text" *ngIf="userProfileForm.get('location')?.errors?.['invalidLocation']">
          Enter a valid location (only letters, numbers, commas)</small>

    </div>

    <div class="form-group">
      <label><i class="bi bi-linkedin"></i> LinkedIn</label>
      <input
        type="text"
        placeholder="e.g. linkedin.com/in/priyasharma"
        formControlName="linkedinUrl"
      />
    </div>

    <div class="form-group full">
      <label><i class="bi bi-github"></i> GitHub / Portfolio</label>
      <input
        type="text"
        placeholder="e.g. github.com/priyasharma"
        formControlName="githubUrl"
      />
    </div>
  </div>
  </form>

  <p class="tip">
    <i class="bi bi-lightbulb"></i>
    Tip: Use a professional email address. Avoid nicknames.
  </p>
</div>
